import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P0003600 } from '../../../../P0003600';
import { P0003601 } from '../../../../P0003601';
import { P0004700 } from '../../../../P0004700';
import { P00046 } from '../../../../P00046';
import { P0003605ESPInstallationClComponent } from '../../../../P0003605/InjectionChlore/EnSavoirPlus/p0003605-espinstallation-cl/p0003605-espinstallation-cl.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P0003606ESPInstallationPhComponent } from '../../../../P0003606/EnSavoirPlus/p0003606-espinstallation-ph/p0003606-espinstallation-ph.component';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00080ConsignPH } from '../../../Enum/P00080Consigne';
import { P00058 } from '../../../../P00058';
import { P0006600 } from '../../../../P0006600';

@Component({
  selector: 'app-p00080-altimeo-mise-en-oeuvre-ph',
  templateUrl: './p00080-altimeo-mise-en-oeuvre-ph.component.html',
  styleUrls: ['./p00080-altimeo-mise-en-oeuvre-ph.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
  ],
})
export class P00080AltimeoMiseEnOeuvrePhComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalController: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {
    this.P00080InstallationPh = this.P00080InstallationPh.bind(this);
  }

  hasProduitP0003600() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003600()) ?? 0;
  }

  hasProduitP0003601() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003601()) ?? 0;
  }

  hasProduitP0004700() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0004700()) ?? 0;
  }

  hasProduitP00046() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00046()) ?? 0;
  }

  hasProduitP00058() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00058()) ?? 0;
  }

  hasProduitP0006600() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0006600()) ?? 0;
  }

  async P00080InstallationPh() {
    const modal = await this.slideModalController.create({
      component: P0003606ESPInstallationPhComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00080ConsignPH = P00080ConsignPH;
}
